export default __webpack_public_path__ + "static/media/ar.3dd319bc.svg";